import React, { useContext } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Select } from "antd";
import Linechart from "../../../components/dashboard/linechart";
import TaskCard from "../../../components/cards/taskCard";
import { useTranslation } from "react-i18next";
import UploadedDocs from "../../../components/dashboard/uploadedDocs";
import { AppContext } from "../../../context/AppContext";
import { useLocation } from "react-router-dom";

const ConfedentialityDetails = () => {
  const { t } = useTranslation();

  const { allCases } = useContext(AppContext); 

  
  const taskcardData = allCases?.data?.map((item) => ({
    heading: item.title || "No Title", 
    date: item.deadline_date
      ? new Date(item.deadline_date).toLocaleString()
      : "No Deadline",
  }));

  const location = useLocation();
    const confeItem = location.state?.confeItem || null;
  
    console.log("Confedential Details:", confeItem); 
  
    if (!confeItem) {
      return <p className="text-darkGrey">No case selected</p>;
    }



  const { Option } = Select;

  const months = [
    "January",
    "March",
    "May",
    "July",
    "August",
    "October",
    "November",
  ];
  // const taskcardData = [
  //   {
  //     heading:
  //       "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  //   {
  //     heading:
  //       "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  //   {
  //     heading:
  //       "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  //   {
  //     heading:
  //       "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  //   {
  //     heading:
  //       "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  // ];
  const contractInfo = [
    {
      label: t("dashboard.confedentialitySecurity.ContractId"),
      value: confeItem.contractId || "N/A",
    },
    {
      label: t("dashboard.confedentialitySecurity.ContractType"),
      value: confeItem.contractType || "N/A",
    },
    {
      label: t("dashboard.confedentialitySecurity.PartyInformation"),
      value: confeItem.partyInformation || "N/A",
    },
    {
      label: t("dashboard.confedentialitySecurity.EffectiveDate"),
      value: confeItem.effectiveDate || "N/A",
    },
    {
      label: t("dashboard.confedentialitySecurity.ExpiryDate"),
      value: confeItem.expiryDate || "N/A",
    },
    {
      label: t("dashboard.confedentialitySecurity.KeyContacts"),
      value: confeItem.keyContacts || "N/A",
    },
    {
      label: t("dashboard.confedentialitySecurity.ClientInformation"),
      value: confeItem.clientInformation || "N/A",
    },
  ];
  return (
    <>
      <div className="dashboard-main flex flex-col gap-[31px] ">
        <div className="top flex gap-[20px] sm-s:flex-col">

        
          
          {/* Confidential Details */}
          <div className="cases-div max-w-[25%] max-sm:max-w-[100%] w-full flex flex-col pt-[18px] pb-[21px] px-[25px] gap-[24px] rounded-[20px] bg-[#F4F4F4] shadow-lg">
            <div className="flex justify-between w-100 items-center">
              <h5 className="small font-bold text-blue">
                {t("dashboard.confedentialitySecurity.details")}
              </h5>
              <p className="e-small bg-[#E0EAF1] font-medium font-poppins text-[#2183C6] rounded-[54px] px-4 py-[6px]">
                {t("dashboard.confedentialitySecurity.caseInProgress")}
              </p>
            </div>
            <div className="flex flex-col gap-[15px]">
              {contractInfo.map(({ label, value }, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between gap-[15px]"
                >
                  <p className="text-darkGrey font-semibold medium">{label}</p>
                  <p className="text-darkGrey font-semibold medium text-right">
                    {value}
                  </p>
                </div>
              ))}
            </div>
          </div>

          
          {/* <div class="reminder-div  flex flex-col gap-[25px] max-w-[75%] max-sm:max-w-[100%] w-full pt-[23px] max-sm:px-[20px] px-[33px] rounded-[20px] border-[1.299px] border-[rgba(255,255,255,0.28)] bg-[#F4F4F4] shadow-lg">
            <h5 className="small font-bold text-blue">
              {t("dashboard.confedentialitySecurity.upcomingTasks")}
            </h5>
            <div className="reminder-card-wrapper bg-transparent flex flex-col gap-[7px] max-sm:pr-[10px] pr-[22px] max-h-[322px] overflow-y-auto">
              <TaskCard taskcardData={taskcardData} />
            </div>
          </div> */}
        </div>
        <UploadedDocs selectedCase={confeItem} />
      </div>
    </>
  );
};

export default ConfedentialityDetails;
